module.exports = __webpack_public_path__ + "static/img/brand-fourth-1.318db79c.png";